import {
    ADD_BULK_CREATED_TAGS_TO_BUSINESS_AREA,
    AI_GENERATE_DATA_TAG_FAILURE,
    AI_GENERATE_DATA_TAG_SUCCESS,
    AI_GENERATE_DESCRIPTION_FAILURE,
    AI_GENERATE_DESCRIPTION_SUCCESS,
    AUTO_TAGGING_FAILURE,
    AUTO_TAGGING_REQUEST,
    AUTO_TAGGING_SUCCESS,
    BULK_CREATE_DATA_TAG_FAILURE,
    BULK_CREATE_DATA_TAG_SUCCESS,
    BULK_UPDATE_DATA_TAG_FAILURE,
    BULK_UPDATE_DATA_TAG_SUCCESS,
    CREATE_DATA_TAG_FAILURE,
    CREATE_DATA_TAG_SUCCESS,
    DELETE_DATA_TAG_FAILURE,
    DELETE_DATA_TAG_SUCCESS,
    DND_TAG,
    GET_DATA_TAG_BY_ID_FAILURE,
    GET_DATA_TAG_BY_ID_SUCCESS,
    GET_DATA_TAGS_BY_BUSINESS_AREA_ID_FAILURE,
    GET_DATA_TAGS_BY_BUSINESS_AREA_ID_SUCCESS,
    GET_DATA_TAGS_FAILURE,
    GET_DATA_TAGS_SUCCESS,
    GET_USER_BUSINESS_AREA_DATA_TAGS_FAILURE,
    GET_USER_BUSINESS_AREA_DATA_TAGS_SUCCESS,
    GET_USER_DATA_TAG_PERMISSION_FAILURE,
    GET_USER_DATA_TAG_PERMISSION_SUCCESS,
    MARK_TAGS_PROCESSING,
    MULTI_DELETE_DATA_TAG_FAILURE,
    MULTI_DELETE_DATA_TAG_SUCCESS,
    REORDER_DATA_TAGS_FAILURE,
    REORDER_DATA_TAGS_REQUEST,
    REORDER_DATA_TAGS_SUCCESS,
    REPHRASE_DATA_TAG_FAILURE,
    REPHRASE_DATA_TAG_SUCCESS,
    RESET_AI_ERRORS,
    RESET_AI_GENERATED_TAGS,
    SET_VIEW_STATE,
    UPDATE_DATA_TAG_FAILURE,
    UPDATE_DATA_TAG_SUCCESS,
} from "./actions";

const initialState = {
    getDataTagsResult: {
        success: true,
    },
    dataTagsResult: {
        Items: [],
    },
    createDataTagResult: {
        success: true,
    },
    getDataTagByIdResult: {
        success: true,
    },
    dataTag: null,
    getDataTagsByBusinessAreaIdResult: {
        success: true,
        businessAreaId: null,
    },
    dataTagsByBusinessAreaIdResult: {
        Items: [],
    },
    getUserBusinessAreaDataTagsResult: {
        success: true,
    },
    userBusinessAreaDataTags: {
        Items: [],
    },
    deleteDataTagResult: {
        success: true,
    },
    updateDataTagResult: {
        success: true,
    },
    bulkUpdateDataTagResult: {
        success: true,
    },
    getUserDataTagPermissionResult: {
        success: true,
    },
    reorderDataTagsResult: {
        success: true,
    },
    multiDeleteDataTagsResult: {
        success: true,
    },
    bulkCreateDataTagResult: {
        success: true,
    },
    aiGenerateDataTagResult: {
        success: true,
    },
    rephraseDataTagResult: {
        success: true,
    },
    aiGenerateDescriptionResult: {
        success: true,
    },
    autoTaggingResult: {
        success: true,
    },
    autoTaggingData: {},
    aiDescription: [],
    bulkCreateTagsResult: [],
    rephrasedDataTag: null,
    aiDataTagsResult: [],
    permission: null,
    dndQueue: [],
    processingQueue: [],
    previousState: [],
    ViewState: "list",
    isUpdating: false,
};

export default (state = initialState, action) => {
    let dataTagsResult = {
        Items: [],
    };
    switch (action.type) {
        case GET_DATA_TAGS_SUCCESS:
            dataTagsResult = action.payload.dataTagsResult;
            return { ...state, getDataTagsResult: { success: true }, dataTagsResult };
        case GET_DATA_TAGS_FAILURE:
            return {
                ...state,
                getDataTagsResult: { success: false, ...action.payload.error },
                dataTagsResult: {
                    Items: [],
                },
            };
        case CREATE_DATA_TAG_SUCCESS:
            return { ...state, createDataTagResult: { success: true } };
        case CREATE_DATA_TAG_FAILURE:
            return { ...state, createDataTagResult: { success: false, ...action.payload.error } };
        case BULK_CREATE_DATA_TAG_SUCCESS:
            return {
                ...state,
                bulkCreateDataTagResult: { success: true },
                bulkCreateTagsResult: action.payload.dataTags,
                dataTagsResult: {
                    ...state.dataTagsResult,
                    Items: [...state.dataTagsResult.Items, ...(action.payload.dataTags || [])],
                },
            };
        case BULK_CREATE_DATA_TAG_FAILURE:
            return { ...state, bulkCreateDataTagResult: { success: false, ...action.payload.error } };
        case ADD_BULK_CREATED_TAGS_TO_BUSINESS_AREA:
            const currentBAId = state.getDataTagsByBusinessAreaIdResult.businessAreaId;
            if (!currentBAId || currentBAId !== action.payload.businessAreaId) {
                return state;
            }
            const newTags = action.payload.dataTags || [];

            if (newTags.length === 0) {
                return state;
            }

            const updateditems = [...state.dataTagsByBusinessAreaIdResult.Items, ...newTags];
            const updatedItemsDict = {
                ...(state.dataTagsByBusinessAreaIdResult.ItemsDict || {}),
            };

            newTags.forEach((tag) => {
                if (tag.tagId) {
                    updatedItemsDict[tag.tagId] = tag;
                }
            });

            return {
                ...state,
                dataTagsByBusinessAreaIdResult: {
                    ...state.dataTagsByBusinessAreaIdResult,
                    Items: updateditems,
                    ItemsDict: updatedItemsDict,
                },
            };
        case AI_GENERATE_DATA_TAG_SUCCESS:
            return { ...state, aiGenerateDataTagResult: { success: true }, aiDataTagsResult: action.payload.dataTag };
        case AI_GENERATE_DATA_TAG_FAILURE:
            return { ...state, aiGenerateDataTagResult: { success: false, ...action.payload.error } };
        case RESET_AI_GENERATED_TAGS:
            return { ...state, aiDataTagsResult: [], aiGenerateDataTagResult: { success: true } };
        case RESET_AI_ERRORS:
            return { ...state, aiGenerateDataTagResult: { success: null }, rephraseDataTagResult: { success: null }, bulkCreateDataTagResult: { success: null } };
        case REPHRASE_DATA_TAG_SUCCESS:
            return { ...state, rephraseDataTagResult: { success: true }, rephrasedDataTag: action.payload.dataTag };
        case REPHRASE_DATA_TAG_FAILURE:
            return { ...state, rephraseDataTagResult: { success: false, ...action.payload.error }, rephrasedDataTag: null };
        case AI_GENERATE_DESCRIPTION_SUCCESS:
            return {
                ...state,
                aiGenerateDescriptionResult: { success: true },
                aiDescription: action.payload.dataTag,
            };
        case AI_GENERATE_DESCRIPTION_FAILURE:
            return { ...state, aiGenerateDescriptionResult: { success: false, ...action.payload.error }, aiDescription: [] };
        case AUTO_TAGGING_REQUEST:
            return { ...state, autoTaggingResult: { loading: true }, autoTaggingData: null };
        case AUTO_TAGGING_SUCCESS:
            return { ...state, autoTaggingResult: { success: true }, autoTaggingData: action.payload.dataTags };
        case AUTO_TAGGING_FAILURE:
            return { ...state, autoTaggingResult: { success: false, ...action.payload.error }, autoTaggingData: [] };
        case GET_DATA_TAG_BY_ID_SUCCESS:
            return { ...state, getDataTagByIdResult: { success: true }, dataTag: action.payload.dataTag };
        case GET_DATA_TAG_BY_ID_FAILURE:
            return { ...state, getDataTagByIdResult: { success: false, ...action.payload.error }, dataTag: null };
        case GET_DATA_TAGS_BY_BUSINESS_AREA_ID_SUCCESS:
            if (action.payload.result && action.payload.result.Items) {
                action.payload.result.ItemsDict = {};
                for (let item of action.payload.result.Items) {
                    action.payload.result.ItemsDict[item.tagId] = item;
                }
            }
            return {
                ...state,
                getDataTagsByBusinessAreaIdResult: { success: true, businessAreaId: action.payload.businessAreaId },
                dataTagsByBusinessAreaIdResult: action.payload.result,
            };
        case GET_DATA_TAGS_BY_BUSINESS_AREA_ID_FAILURE:
            return {
                ...state,
                getDataTagsByBusinessAreaIdResult: { success: false, businessAreaId: action.payload.businessAreaId, ...action.payload.error },
                dataTagsByBusinessAreaIdResult: { Items: [] },
            };
        case GET_USER_BUSINESS_AREA_DATA_TAGS_SUCCESS:
            return { ...state, getUserBusinessAreaDataTagsResult: { success: true }, userBusinessAreaDataTags: action.payload.result };
        case GET_USER_BUSINESS_AREA_DATA_TAGS_FAILURE:
            return { ...state, getUserBusinessAreaDataTagsResult: { success: false, ...action.payload.error }, userBusinessAreaDataTags: { Items: [] } };
        case DELETE_DATA_TAG_SUCCESS:
            dataTagsResult = { ...state.dataTagsResult };
            dataTagsResult.Items = state.dataTagsResult.Items.filter((dataTag) => dataTag.tagId !== action.payload.tagId);
            return { ...state, deleteDataTagResult: { success: true }, dataTagsResult };
        case DELETE_DATA_TAG_FAILURE:
            return { ...state, deleteDataTagResult: { success: false, ...action.payload.error } };
        case MULTI_DELETE_DATA_TAG_SUCCESS:
            // console.log('MULTI_DELETE_DATA_TAG_SUCCESS', action.payload.tagIds);
            dataTagsResult = { ...state.dataTagsResult };
            dataTagsResult.Items = state.dataTagsResult.Items.filter((dataTag) => !action.payload.tagIds.some((tag) => tag.tagId === dataTag.tagId));
            return { ...state, multiDeleteDataTagsResult: { success: true }, dataTagsResult };
        case MULTI_DELETE_DATA_TAG_FAILURE:
            return { ...state, multiDeleteDataTagsResult: { success: false, ...action.payload.error } };
        case UPDATE_DATA_TAG_SUCCESS:
            return { ...state, updateDataTagResult: { success: true } };
        case UPDATE_DATA_TAG_FAILURE:
            return { ...state, updateDataTagResult: { success: false, ...action.payload.error } };
        case BULK_UPDATE_DATA_TAG_SUCCESS:
            return { ...state, bulkUpdateDataTagResult: { success: true } };
        case BULK_UPDATE_DATA_TAG_FAILURE:
            return { ...state, bulkUpdateDataTagResult: { success: false, ...action.payload.error } };
        case GET_USER_DATA_TAG_PERMISSION_SUCCESS:
            return { ...state, getUserDataTagPermissionResult: { success: true }, permission: action.payload.permission };
        case GET_USER_DATA_TAG_PERMISSION_FAILURE:
            return { ...state, getUserDataTagPermissionResult: { success: false, ...action.payload.error }, permission: null };
        case DND_TAG:
            // console.log("DND_TAG action received:", action.payload);
            const { tagId, sortOrder, oldSortOrder } = action.payload.datatag;
            const updatedItems = state.dataTagsResult.Items.map((tag) => (tag.tagId === tagId ? { ...tag, sortOrder: sortOrder } : tag));
            const sortedItems = updatedItems.sort((a, b) => a.sortOrder - b.sortOrder);
            return {
                ...state,
                dndQueue: [...state.dndQueue, action.payload.datatag],
                previousState: [...state.dataTagsResult.Items],
                dataTagsResult: { ...state.dataTagsResult, Items: sortedItems },
            };
        case REORDER_DATA_TAGS_REQUEST:
            // console.log("Datattagreq action received:", action.params);
            return {
                ...state,
                previousState: [...state.dataTagsResult.Items],
                dndQueue: [...state.dndQueue, ...action.params.dataTags],
                isUpdating: true,
            };

        case REORDER_DATA_TAGS_SUCCESS:
            return {
                ...state,
                dndQueue: state.dndQueue.filter((item) => !state.processingQueue.find((pItem) => pItem.tagId === item.tagId && pItem.newSortOrder === item.newSortOrder)),
                processingQueue: [],
                isUpdating: false,
                reorderDataTagsResult: { success: true },
            };

        case REORDER_DATA_TAGS_FAILURE:
            return {
                ...state,
                dataTagsResult: {
                    Items: state.previousState,
                },
                processingQueue: [],
                isUpdating: false,
                reorderDataTagsResult: {
                    success: false,
                    error: action.payload.error || "Reordering failed due to an unknown error",
                },
            };
        case MARK_TAGS_PROCESSING:
            return {
                ...state,
                processingQueue: action.payload.tags,
                isUpdating: true,
            };
        case SET_VIEW_STATE:
            return {
                ...state,
                ViewState: action.payload.viewState,
            };
        default:
            return state;
    }
};
